import ClickToOpen from "./click-to-open.js";
import { l as layout } from "./layout-store.js";
import { E } from "./preact-core.js";
class SlideOver extends ClickToOpen {
  constructor() {
    super();
    this.direction = "right";
    this.restricted = false;
    this.type = null;
    this.paramsOpened = false;
    this.visible = false;
    this.isOpen = true;
    this.typeClasses = [`slideover--${this.direction}`];
    this.layout = layout;
    this.slideoverEl = this.querySelector(".slideover");
    this.closeEl = this.querySelector(".close");
    if (!this.slideoverEl) {
      console.error("Slideover couldn't find slideover element");
      console.log(this);
      return;
    }
    if (this.id === void 0 || this.id == null) {
      console.error("Slideover needs id value");
      console.log(this);
      return;
    }
    this.type = this.dataset.type;
    if (this.type) {
      this.typeClasses.push(`slideover--${this.type}`);
    }
    this.typeClasses.forEach((cl) => {
      this.slideoverEl.classList.add(cl);
    });
    E(() => {
      if (this.layout.slideover.value == this.id) {
        this.isOpen = true;
        document.body.classList.add("slideover-open");
        this.slideoverEl.classList.add("active");
      } else {
        this.isOpen = false;
        document.body.classList.remove("slideover-open");
        this.slideoverEl.classList.remove("active");
      }
      document.documentElement.style.overflow = this.isOpen ? "hidden" : "";
    });
    this.querySelectorAll("a").forEach((el) => {
      el.addEventListener("click", (e) => {
        if (this.isOpen) {
          this.close();
        }
      });
    });
  }
  open() {
    this.layout.slideover.value = this.id;
    this.dispatchEvent(new Event("open", { bubbles: true, composed: true }));
  }
  close() {
    this.layout.slideover.value = null;
    this.visible = true;
    this.dispatchEvent(new Event("close", { bubbles: true, composed: true }));
  }
}
if (!customElements.get("slide-over")) {
  customElements.define("slide-over", SlideOver);
}
export {
  SlideOver,
  SlideOver as default
};
